import { createCachedSelector } from 're-reselect';

import getModels from '@/state/selectors/navigation/get-models';
import { IStore } from '@/state/slices/typings';

const getModel = createCachedSelector(
	[getModels, (_: IStore, endpoint: string | undefined) => endpoint],
	(models, endpoint) => {
		if (!endpoint) return null;
		return models[endpoint];
	},
)((_: IStore, endpoint: string | undefined) => endpoint ?? '');

export default getModel;
